import turbodata from './raw/turbo.json';

export const TurboColorMap = type => {
  if (type === 'range') {
    return turbodata;
  }
};
